export const productsData = [
  {
    id: 1,
    name: 'ユースエナジー',
    category: 'ユース世代向け',
    targetAge: '10代-20代',
    description: '成長期から社会人デビューまでの若い世代をサポート。ビタミンB群、鉄分、亜鉛を配合し、活力ある毎日を応援します。',
    features: ['ビタミンB群配合', '鉄分・亜鉛強化', '集中力サポート'],
    image:
      'https://public.readdy.ai/ai/img_res/4349a0458af7fa9c3aff694f1577ad72.jpg',
    details: {
      ingredients:
        'ビタミンB1、ビタミンB2、ビタミンB6、ビタミンB12、鉄分（クエン酸鉄）、亜鉛（グルコン酸亜鉛）、セルロース、ステアリン酸カルシウム、微粒二酸化ケイ素、HPMC（カプセル）',
      allergens: '該当なし',
      content: '60粒入り（約30日分）／1粒あたり350mg',
      nutrition:
        'ビタミンB1：1.2mg、ビタミンB2：1.4mg、ビタミンB6：1.3mg、ビタミンB12：2.4μg、鉄：6.8mg、亜鉛：8.8mg（2粒あたり）',
      usage: '1日2粒を目安に、水またはぬるま湯でお召し上がりください。',
      caution:
        '体質に合わない場合は使用を中止してください。妊娠・授乳中の方は医師にご相談ください。お子様の手の届かない場所に保管してください。',
    },
  },
  {
    id: 2,
    name: 'エナジーサポートプラス',
    category: 'ミドル世代向け',
    targetAge: '30代-50代',
    description:
      '忙しいビジネスパーソンのための疲労回復サプリメント。コエンザイムQ10、マカ、高麗人参エキスで活力をチャージ。',
    features: ['疲労回復サポート', 'コエンザイムQ10配合', 'ストレス対策'],
    image:
      'https://readdy.ai/api/search-image?query=premium%20supplement%20bottle%20with%20sophisticated%20professional%20design%20featuring%20ginseng%20root%20and%20natural%20herbs%20on%20elegant%20white%20background%20with%20soft%20studio%20lighting%20product%20photography%20high%20resolution&width=400&height=400&seq=prod2&orientation=squarish',
    details: {
      ingredients:
        'コエンザイムQ10、マカエキス末、高麗人参エキス末、ビタミンE、ビタミンC、セルロース、ステアリン酸カルシウム、微粒二酸化ケイ素、HPMC（カプセル）',
      allergens: '該当なし',
      content: '90粒入り（約30日分）／1粒あたり400mg',
      nutrition:
        'コエンザイムQ10：100mg、マカエキス：200mg、高麗人参エキス：50mg、ビタミンE：6.3mg、ビタミンC：50mg（3粒あたり）',
      usage: '1日3粒を目安に、水またはぬるま湯でお召し上がりください。',
      caution:
        '医薬品を服用中の方は医師にご相談ください。過剰摂取はお控えください。直射日光・高温多湿を避けて保管してください。',
    },
  },
  {
    id: 3,
    name: 'アクティブシニアサポート',
    category: 'シニア世代向け',
    targetAge: '50代以上',
    description:
      'いつまでも元気に過ごしたいシニア世代へ。グルコサミン、コンドロイチン、カルシウムで関節と骨の健康を守ります。',
    features: ['関節サポート', 'カルシウム強化', '記憶力サポート'],
    image:
      'https://readdy.ai/api/search-image?query=gentle%20supplement%20bottle%20with%20warm%20caring%20design%20featuring%20calcium%20rich%20foods%20and%20joint%20health%20ingredients%20on%20soft%20white%20background%20with%20natural%20daylight%20product%20photography%20premium%20quality&width=400&height=400&seq=prod3&orientation=squarish',
    details: {
      ingredients:
        'グルコサミン塩酸塩（えび・かに由来）、サメ軟骨抽出物（コンドロイチン含有）、カルシウム（貝殻由来）、ビタミンD、ビタミンK、セルロース、ステアリン酸カルシウム、HPMC（カプセル）',
      allergens: 'えび・かに',
      content: '120粒入り（約30日分）／1粒あたり450mg',
      nutrition:
        'グルコサミン：1500mg、コンドロイチン：200mg、カルシウム：300mg、ビタミンD：5.5μg、ビタミンK：60μg（4粒あたり）',
      usage:
        '1日4粒を目安に、水またはぬるま湯でお召し上がりください。朝・夕の食後に2粒ずつの摂取をおすすめします。',
      caution:
        'えび・かにアレルギーの方はお召し上がりにならないでください。血液凝固阻止薬を服用中の方は医師にご相談ください。',
    },
  },
  {
    id: 4,
    name: 'マタニティケア',
    category: '妊婦向け',
    targetAge: '妊娠中・授乳中',
    description:
      '妊娠中・授乳中のママと赤ちゃんのために。葉酸、鉄分、カルシウムをバランスよく配合した安心サプリメント。',
    features: ['葉酸400μg配合', '鉄分・カルシウム', '無添加処方'],
    image:
      'https://readdy.ai/api/search-image?query=gentle%20supplement%20bottle%20with%20soft%20maternal%20design%20featuring%20folic%20acid%20rich%20vegetables%20and%20calcium%20sources%20on%20pure%20white%20background%20with%20tender%20natural%20lighting%20product%20photography%20high%20quality&width=400&height=400&seq=prod4&orientation=squarish',
    details: {
      ingredients:
        '葉酸、クエン酸鉄、カルシウム（貝殻由来）、ビタミンB6、ビタミンB12、ビタミンD、セルロース、HPMC（カプセル）',
      allergens: '該当なし',
      content: '60粒入り（約30日分）／1粒あたり300mg',
      nutrition:
        '葉酸：400μg、鉄：10mg、カルシウム：200mg、ビタミンB6：1.4mg、ビタミンB12：2.8μg、ビタミンD：7.0μg（2粒あたり）',
      usage: '1日2粒を目安に、水またはぬるま湯でお召し上がりください。',
      caution:
        '本品は多量摂取により疾病が治癒したり、より健康が増進するものではありません。1日の摂取目安量を守ってください。かかりつけの医師にご相談の上お召し上がりください。',
    },
  },
  {
    id: 5,
    name: 'キッズグロース',
    category: '子供向け',
    targetAge: '成長期の子供',
    description:
      '成長期のお子様の発育をサポート。カルシウム、ビタミンD、DHAで健やかな成長を応援します。',
    features: ['カルシウム配合', 'ビタミンD強化', 'DHA配合'],
    image:
      'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/a6e1e2e82c372da7716cce80e11165fa.jpeg',
    details: {
      ingredients:
        'カルシウム（貝殻由来）、DHA含有精製魚油、ビタミンD、ビタミンK、乳酸菌末、セルロース、甘味料（キシリトール）、香料、HPMC（カプセル）',
      allergens: '乳成分・大豆',
      content: '90粒入り（約30日分）／1粒あたり250mg（チュアブルタイプ）',
      nutrition:
        'カルシウム：350mg、DHA：100mg、ビタミンD：3.0μg、ビタミンK：30μg、乳酸菌：1億個（3粒あたり）',
      usage: '1日3粒を目安に、噛んでお召し上がりください。ヨーグルト味で小さなお子様でも食べやすい設計です。',
      caution:
        '小さなお子様が召し上がる際は保護者の監督のもとお召し上がりください。食物アレルギーのある方は原材料をご確認ください。',
    },
  },
  {
    id: 6,
    name: 'マルチビタミン',
    category: '栄養補助',
    targetAge: '全年齢',
    description:
      '日々の栄養バランスをサポート。12種類のビタミンと8種類のミネラルを配合した総合栄養サプリメント。',
    features: ['12種類のビタミン', '8種類のミネラル', '全年齢対応'],
    image:
      'https://readdy.ai/api/search-image?query=comprehensive%20supplement%20bottle%20with%20balanced%20nutrition%20design%20featuring%20colorful%20fresh%20fruits%20and%20vegetables%20on%20clean%20white%20background%20with%20bright%20natural%20lighting%20product%20photography%20high%20resolution&width=400&height=400&seq=prod6&orientation=squarish',
    details: {
      ingredients:
        'ビタミンA、ビタミンB1、ビタミンB2、ビタミンB6、ビタミンB12、ビタミンC、ビタミンD、ビタミンE、ビタミンK、ナイアシン、パントテン酸、葉酸、カルシウム、マグネシウム、鉄、亜鉛、銅、マンガン、セレン、クロム、セルロース、HPMC（カプセル）',
      allergens: '該当なし',
      content: '60粒入り（約30日分）／1粒あたり500mg',
      nutrition:
        'ビタミンA：450μg、ビタミンC：100mg、ビタミンD：5.5μg、ビタミンE：6.3mg、カルシウム：150mg、マグネシウム：75mg、鉄：3.5mg、亜鉛：4.0mg（2粒あたり）',
      usage:
        '1日2粒を目安に、水またはぬるま湯でお召し上がりください。食後の摂取をおすすめします。',
      caution:
        '他のサプリメントとの併用時はビタミン・ミネラルの過剰摂取にご注意ください。異常を感じた場合は使用を中止し医師にご相談ください。',
    },
  },
  {
    id: 7,
    name: 'カルシウムプラス',
    category: '栄養補助',
    targetAge: '全年齢',
    description:
      '骨の健康維持に欠かせないカルシウムを効率的に摂取。ビタミンDとマグネシウムも配合で吸収率アップ。',
    features: ['高濃度カルシウム', 'ビタミンD配合', 'マグネシウム配合'],
    image:
      'https://readdy.ai/api/search-image?query=clean%20supplement%20bottle%20with%20bone%20health%20design%20featuring%20dairy%20products%20and%20calcium%20rich%20ingredients%20on%20pure%20white%20background%20with%20soft%20studio%20lighting%20product%20photography%20premium%20quality&width=400&height=400&seq=prod7&orientation=squarish',
    details: {
      ingredients:
        'カルシウム（貝殻由来）、酸化マグネシウム、ビタミンD、ビタミンK、CPP（カゼインホスホペプチド）、セルロース、ステアリン酸カルシウム、HPMC（カプセル）',
      allergens: '乳成分',
      content: '120粒入り（約30日分）／1粒あたり400mg',
      nutrition:
        'カルシウム：500mg、マグネシウム：250mg、ビタミンD：10.0μg、ビタミンK：60μg、CPP：30mg（4粒あたり）',
      usage: '1日4粒を目安に、水またはぬるま湯でお召し上がりください。朝・夕に分けての摂取をおすすめします。',
      caution:
        '乳アレルギーの方はお召し上がりにならないでください。腎臓に疾患のある方は医師にご相談ください。',
    },
  },
  {
    id: 8,
    name: '鉄分サポートプレミアム',
    category: '栄養補助',
    targetAge: '全年齢',
    description:
      '不足がちの鉄分を効率よく補給。ヘム鉄と非ヘム鉄をバランスよく配合し、ビタミンCが吸収をサポートします。',
    features: ['ヘム鉄配合', '吸収率アップ', '葉酸・ビタミンB12配合'],
    image:
      'https://readdy.ai/api/search-image?query=elegant%20supplement%20bottle%20with%20iron%20supplement%20design%20featuring%20spinach%20liver%20red%20meat%20and%20dark%20green%20vegetables%20on%20clean%20white%20background%20with%20warm%20natural%20lighting%20product%20photography%20high%20quality%20sharp%20focus&width=400&height=400&seq=prod8b&orientation=squarish',
    details: {
      ingredients:
        'ヘム鉄（豚由来）、クエン酸鉄ナトリウム、ビタミンC、葉酸、ビタミンB12、銅（グルコン酸銅）、セルロース、ステアリン酸カルシウム、微粒二酸化ケイ素、HPMC（カプセル）',
      allergens: '豚肉',
      content: '60粒入り（約30日分）／1粒あたり350mg',
      nutrition:
        'ヘム鉄：5mg、非ヘム鉄：5mg（総鉄分10mg）、ビタミンC：80mg、葉酸：200μg、ビタミンB12：2.4μg、銅：0.6mg（2粒あたり）',
      usage: '1日2粒を目安に、水またはぬるま湯でお召し上がりください。空腹時の摂取が吸収に効果的です。',
      caution:
        '鉄剤を服用中の方は医師にご相談ください。過剰摂取は消化器症状を引き起こす場合があります。お茶・コーヒーとの同時摂取は吸収を妨げる場合があります。',
    },
  },
  {
    id: 9,
    name: 'オメガ3フィッシュオイル',
    category: '栄養補助',
    targetAge: '全年齢',
    description:
      '青魚由来のDHA・EPAを高濃度配合。脳の健康と血液サラサラをサポートします。',
    features: ['DHA・EPA配合', '血液サラサラ', '脳の健康サポート'],
    image:
      'https://readdy.ai/api/search-image?query=premium%20supplement%20bottle%20with%20omega%203%20design%20featuring%20fresh%20fish%20and%20marine%20ingredients%20on%20clean%20white%20background%20with%20cool%20natural%20lighting%20product%20photography%20high%20resolution&width=400&height=400&seq=prod9&orientation=squarish',
    details: {
      ingredients: 'DHA含有精製魚油、EPA含有精製魚油、ビタミンE、ゼラチン（カプセル）、グリセリン',
      allergens: 'ゼラチン',
      content: '90粒入り（約30日分）／1粒あたり500mg（ソフトカプセル）',
      nutrition: 'DHA：400mg、EPA：200mg、ビタミンE：6.3mg（3粒あたり）',
      usage: '1日3粒を目安に、水またはぬるま湯でお召し上がりください。食事と一緒に摂取すると吸収が高まります。',
      caution:
        '血液凝固阻止薬を服用中の方は医師にご相談ください。手術予定のある方は事前に医師にお伝えください。魚アレルギーの方はお控えください。',
    },
  },
];
